<template>
  <v-dialog v-model="dialog" max-width="700px" persistent>
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Update category data</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-select
                v-model="editedItem.category"
                :items="categories"
                label="category"
                filled
                v-validate="{
                  required: true
                }"
                name="category"
                :error-messages="errors.collect('category')"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="94"
                type="list-item-two-line"
              >
                <v-text-field
                  v-model="editedItem.coefficient_for_radius"
                  label="Coefficient for radius"
                  filled
                  v-validate="{
                    required: true
                  }"
                  name="coefficient for radius"
                  :error-messages="errors.collect('coefficient for radius')"
                />
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dialog: false,
      editedItem: {
        category: 'map_optimization',
        coefficient_for_radius: 'none'
      },
      defaultItem: {
        category: 'map_optimization',
        coefficient_for_radius: 'none'
      },
      loading: false
    }
  },
  watch: {
    async dialog (val) {
      if (val) {
        await this.loadCategoryData(this.editedItem.category)
      } else {
        this.close()
      }
    },
    async 'editedItem.category' (category) {
      await this.loadCategoryData(category)
    }
  },
  methods: {
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = { ...this.defaultItem }
        this.$emit('update', null)
      }, 300)
    },
    async loadCategoryData (category) {
      this.loading = true
      let { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/runtime-category-data/' + category)

      if (data) {
        this.editedItem = { ...this.editedItem, ...data }
      } else {
        this.editedItem = { ...this.defaultItem, category }
      }

      this.loading = false
    },
    save () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          await this.$axios.post(this.$store.getters.projectPath + '/configs/runtime-category-data', { ...this.editedItem })
          .catch(error => ({ data: { err: true, message: error.response.data } }))

          if (data.err) {
            this.$toasted.error(data.message)
          } else {
            this.close()
          }
        }
      })
    }
  }
}
</script>